/**
 * ERP nomenklatúra entitás kód -> i18n kulcs leképezés.
 * Egy helyen tartva, hogy a tab fülek és a szinkron napló ugyanazt
 * a többnyelvű megnevezést használják.
 */
const ENTITY_LABEL_KEYS = {
  MEASURE_UNITS: "tools.erp_integration.tab_measure_units",
  PRODUCT_TYPES: "tools.erp_integration.tab_product_types",
  WAREHOUSES: "tools.erp_integration.tab_warehouses",
  LEGAL_ENTITIES: "tools.erp_integration.tab_legal_entities",
  PARCELS: "tools.erp_integration.tab_parcels",
  WORK_TYPES: "tools.erp_integration.tab_work_types",
  SEASONS: "tools.erp_integration.tab_seasons",
  CULTURES: "tools.erp_integration.tab_cultures",
  PARTNERS: "tools.erp_integration.tab_partners",
  PRODUCTS: "tools.erp_integration.tab_products",
  WORK_INVOICES: "tools.erp_integration.consum_work_invoice_logs",
};

export function getErpEntityLabelKey(code) {
  return ENTITY_LABEL_KEYS[(code || "").toUpperCase()] || "";
}

/**
 * @param {Function} translate a komponens $t függvénye
 * @param {String} code entitás kód
 * @param {String} fallback tartalék megnevezés, ha nincs fordítási kulcs
 */
export function translateErpEntityLabel(translate, code, fallback = "") {
  const key = getErpEntityLabelKey(code);

  if (key && typeof translate === "function") {
    return translate(key);
  }

  return fallback || code || "";
}
